import "./App.css";
import Router from "./router/router.jsx";
import ScrollToTop from "./components/ScrollToTop";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ProPlanPopup from "./components/ProPlanPopup";
import { shouldShowPopup } from "./utils/proPlanAnnouncement";
import RateLimitNotice from "./components/RateLimitNotice/RateLimitNotice";

function App() {
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (location.pathname === "/apply-for-membership") {
      setShowPopup(false);
      return undefined;
    }

    const timer = setTimeout(() => {
      if (shouldShowPopup()) {
        setShowPopup(true);
      }
    }, 1500);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <ScrollToTop />
      <Router />
      <RateLimitNotice />
      {showPopup && <ProPlanPopup onClose={() => setShowPopup(false)} />}
    </>
  );
}

export default App;

// import "./App.css";
// import Router from "./router/router.jsx";
// import ScrollToTop from "./components/ScrollToTop";


// function App() {
//   return (
//     <>
//       <ScrollToTop />
//       <Router />
//     </>
//   );
// }

// export default App;
